export enum AvailableFAQType {
    calculatorSelfServeSuccess = "calculatorSelfServeSuccess",
    labelingPlatformMain = "labelingPlatformMain",
}

// For now not used, in the future can be used to manage different API versions
export enum ApiVersion {
    V1 = "v1",
    V2 = "v2",
}

export const COMMON_GENERAL_CONFIG = {
    defaultApiVersion: ApiVersion.V1,

    defaultMomentDateFormat: "MM/DD/YYYY",
    defaultMomentDateFormatShortYear: "MM/DD/YY",
    defaultSimplifiedMomentDateFormat: "M/D/YYYY",
    secondarySimplifiedMomentDateFormat: "MM/D/YYYY",
    tertiarySimplifiedMomentDateFormat: "M/DD/YYYY",
    secondaryMomentDateFormat: "MM-DD-YYYY",
    unpunctuatedMomentDateFormat: "MMDDYYYY",
    mysqlMomentDateFormat: "YYYY-MM-DD",
    isoNoTzMomentDateFormat: "YYYY-MM-DDTHH:mm:ss.SSS",
    monthYearMomentDateFormat: "MMMM YYYY",
    defaultMomentDateFormatReadable: "MMM D. YYYY",
    defaultMomentDateTimeFormat: "MM/DD/YYYY HH:mm:ss",
    defaultMomentHourMinutesFormat: "HH:mm",
    defaultMomentDateTimeFormatReadable: "MMM D, YYYY h:mm A",

    idleTimeoutSeconds: 60 * 60,
}
